import { IonAlert, IonButton, IonCheckbox, IonIcon, IonInput, IonItem, IonLabel, IonList, IonRadio, IonRadioGroup } from '@ionic/react';
import mobiscroll from '@mobiscroll/react';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Geolocation } from '@capacitor/geolocation';
import { getConfig } from '../../appConfig';
import { FieldError, NormalText, Sectiontitle, SmallText, Spacer, StrongText, Title } from '../../components/common';
import Layout from '../../components/layout';
import Mobiscroll from '../../components/mobiscroll';
import NoData from '../../components/noData';
import Loading from '../../components/spinner';
import api from '../../lib/api';
import Basket from '../../lib/basket';
import moment from '../../lib/moment';
import { withTranslation } from '../../lib/translate';
import {
	checkForDeliveryOption,
	deepCopy,
	forwardTo,
	getDistanceUnit,
	goBack,
	groupBy,
	isArray,
	isDefined,
	isObject,
	isWebConfig,
	parseAllergenData,
	weekdays,
	getRestaurantOpeningTime,
	createMomentFromTime,
	isTimeAvaibleInMenu,
	isEmptyObject,
	isTimeInRange,
	uniqueByProperty,
	isNative,
	sendToAnalytics,
} from '../../lib/utils';
import { setDeliveryOption } from '../../store/actions';
import { loading, setCommonModal, setMyLocation, showToast, setCommonProp } from '../../store/common/actions';
import { SET_RESTAURANT_PROP } from '../../store/constants';
import { getIkentooMenu, getIkentooMenusForLocation, getRestaurants } from '../../store/restaurants/actions';
import { filterMenu } from '../../store/restaurants/sagas';
import 'moment-timezone';
import './index.css';
import 'moment-timezone';
import Modal from '../../components/modal';
import CuratedMenusLink from '../../components/curatedMenusLink';
import { ReactComponent as LocationDisabledIcon } from '../../assets/images/location-disabled.svg';
import { search } from 'ionicons/icons';

const { shouldAddPrepTime } = Basket;

const { SelectOption } = Mobiscroll;
const toWhichSegmentTimeBelongs = (time, segments = []) => {
	let timeIsInSegment = -1;
	segments.forEach((segment, index) => {
		const { start, end } = segment;
		const targetTime = createMomentFromTime(time);
		const segmentStart = createMomentFromTime(start);
		const segmentEnd = createMomentFromTime(end);
		if (targetTime.isSameOrAfter(segmentStart) && targetTime.isSameOrBefore(segmentEnd)) {
			timeIsInSegment = index;
		}
	});
	return timeIsInSegment;
};

const isTimeInSegment = (time, segments = [], print) => {
	return toWhichSegmentTimeBelongs(time, segments) !== -1;
};

export const getEffectiveAvailability = (availability = [], day) => {
	return availability
		.filter((i) => i?.active !== false)
		.filter((i) => i.d === `w${day}`)
		.flatMap((time) => {
			const { start, end, unavailable_times, d } = time;
			if (unavailable_times && unavailable_times[0]?.start && unavailable_times[0]?.end) {
				const segments = [];
				if (start < unavailable_times[0].start) segments.push({ d, start, end: unavailable_times[0].start });
				if (unavailable_times[0].end < end) segments.push({ d, start: unavailable_times[0].end, end });
				return segments;
			}
			return [{ d, start, end }];
		});
};

const addSegment = (start, end, segments = [], date) => {
	let updatedSegments = [...segments];
	const dayNumber = 'w' + date.day();
	const newSegment = { d: dayNumber, start: start, end: end };

	// check previously added segment. maybe some of them are handled with new added segment
	const oldSegments = [...segments];
	oldSegments.forEach((oldSegment, index) => {
		if (isTimeInSegment(oldSegment.start, [newSegment]) && isTimeInSegment(oldSegment.end, [newSegment])) {
			updatedSegments = removeSegment(index, updatedSegments);
		}
	});
	return [...updatedSegments, newSegment];
};

const updateSegment = (segmentIndex, propName, value, segments = []) => {
	let updatedSegments = [...segments];
	if (updatedSegments && updatedSegments[segmentIndex]) {
		updatedSegments[segmentIndex][propName] = value;
	}
	return updatedSegments;
};

const removeSegment = (segmentIndexForRemove, segments = []) => [...segments].map((segment, index) => (index === segmentIndexForRemove ? null : segment)).filter((segment) => isDefined(segment));

const parseTimesJson = (json = [], date) => {
	let parsed_json = [];
	const dayNumber = 'w' + date.day();
	// use old logic for 'json_time_selector' json (without: menuId and availabity)
	if (json.length > 0 && !json[0].menuId) {
		return json;
	}

	json.forEach((menu) => {
		(menu.availability || [])
			.filter((i) => i?.active !== false)
			.filter((i) => i.d === dayNumber)
			.forEach((time) => {
				const { start, end, unavailable_times } = time;
				let availableTimes = [];
				if (unavailable_times && unavailable_times?.[0]?.start && unavailable_times?.[0]?.end) {
					const uStart = unavailable_times[0].start;
					const uEnd = unavailable_times[0].end;
					if (start < uStart) availableTimes.push({ d: dayNumber, start, end: uStart });
					const minDT = moment().tz(getConfig().timezone);
					if (!Basket.getRestaurant()?.enable_past_midnight_orders?.includes(Basket.order_type)) {
						if (uEnd < end) availableTimes.push({ d: dayNumber, start: uEnd, end });
					} else {
						if (!minDT.isBetween(moment(start, 'HH:mm'), moment(uStart, 'HH:mm'), null, '[]')) {
							if (uEnd < end) availableTimes.push({ d: dayNumber, start: uEnd, end });
						}
					}
				} else {
					availableTimes.push({ d: dayNumber, start, end });
				}
				availableTimes.forEach((availableTime) => {
					const { start, end } = availableTime;
					if (parsed_json.length === 0) {
						// add first available time
						parsed_json = addSegment(start, end, parsed_json, date);
					} else {
						if (!isTimeInSegment(start, parsed_json) && !isTimeInSegment(end, parsed_json)) {
							// case 1: start and end dont belong to any other segment
							parsed_json = addSegment(start, end, parsed_json, date);
						} else if (isTimeInSegment(start, parsed_json) && !isTimeInSegment(end, parsed_json)) {
							// case 2: start belong to some segment and end dont bolong to any segment
							const segmentIndex = toWhichSegmentTimeBelongs(start, parsed_json);
							parsed_json = updateSegment(segmentIndex, 'end', end, parsed_json);
						} else if (!isTimeInSegment(start, parsed_json) && isTimeInSegment(end, parsed_json)) {
							// case 3: end belong to some segment and start dont bolong to any segment
							const segmentIndex = toWhichSegmentTimeBelongs(end, parsed_json);
							parsed_json = updateSegment(segmentIndex, 'start', start, parsed_json);
						} else if (isTimeInSegment(start, parsed_json) && isTimeInSegment(end, parsed_json)) {
							// case 4: and start and end belongs to some segment
							const startSegmentIndex = toWhichSegmentTimeBelongs(start, parsed_json);
							const endSegmentIndex = toWhichSegmentTimeBelongs(end, parsed_json);
							if (parsed_json && parsed_json[startSegmentIndex] && parsed_json[endSegmentIndex]) {
								const newStartTime = parsed_json[startSegmentIndex].start;
								const newEndTime = parsed_json[endSegmentIndex].end;

								if (startSegmentIndex !== endSegmentIndex) {
									parsed_json = addSegment(newStartTime, newEndTime, parsed_json, date);
									parsed_json = removeSegment(startSegmentIndex, parsed_json);
									parsed_json = removeSegment(endSegmentIndex, parsed_json);
								}
							}
						}
					}
				});
			});
	});

	// sort times by 'start' time
	return parsed_json.sort((a, b) => {
		const aStart = createMomentFromTime(a.start);
		const bStart = createMomentFromTime(b.start);
		return bStart.isSameOrBefore(aStart) ? 1 : -1;
	});
};

export const getMenusForSelectedTime = (menusForLocation = [], time, json_time_selector = [], isNextDay = false) => {
	if (isObject(menusForLocation) && !isArray(menusForLocation)) {
		menusForLocation = [menusForLocation];
	}
	let day = moment().tz(getConfig().timezone).day();
	if (Basket.order_type == 'scheduled-delivery' || Basket.order_type == 'scheduled-collection') {
		day = moment(Basket.getCollectionTime()).format('d');
	}
	if (isNextDay) {
		day = moment().add('days', 1).tz(getConfig().timezone).day();
	}
	let pickTime = time;
	if (pickTime === 'asap') {
		pickTime = moment().tz(getConfig().timezone).format('H:mm');
	}
	return menusForLocation.filter((menu) => {
		const ikentooMenuId = menu.ikentooMenuId;
		if (json_time_selector.length > 0 && json_time_selector[0].menuId && pickTime && ikentooMenuId) {
			const target_menus = json_time_selector.filter((i) => i.menuId.toString() === ikentooMenuId.toString());
			for (let i = 0; i < target_menus.length; i++) {
				if (
					target_menus[i] &&
					isTimeInSegment(
						pickTime,
						getEffectiveAvailability(target_menus[i].availability, day),
					)
				) {
					return true;
				}
			}
		} else {
			// handle old json_time_selector (without menuId and availability)
			return false;
		}

		return false;
	});
};

export const checkSnoozedTimes = (store, order_type) => {
	if (!store) {
		return null;
	}
	let snoozed_disabled = [];
	/* eslint-disable */
	if (store.hasOwnProperty('snoozed_times')) {
		/* eslint-enable */
		const snoozed_times = store.snoozed_times;
		snoozed_disabled.push(...(snoozed_times[order_type] ? snoozed_times[order_type] : Array.isArray(snoozed_times) ? snoozed_times : []));
	}
	/* eslint-disable */
	if (store.hasOwnProperty('disabled_times')) {
		/* eslint-enable */
		const disabled_times = store.disabled_times;
		snoozed_disabled.push(...(disabled_times[order_type] ? disabled_times[order_type] : Array.isArray(disabled_times) ? disabled_times : []));
	}
	return snoozed_disabled;
};
const generateTimeSlots = (start, end, slot) => {
	const slots = [];
	const startTime = moment.tz(start, 'HH:mm', getConfig().timezone);
	const endTime = moment.tz(end, 'HH:mm', getConfig().timezone);
	while (startTime < endTime) {
		slots.push({
			disabled: false,
			text: startTime.format('HH:mm'),
			html: `<span data-test='${startTime.valueOf()}'>${startTime.format('h:mm a')}</span>`,
			isNextDay: true,
			value: startTime.format('HH:mm'),
		});
		startTime.add(slot, 'minutes');
	}
	return slots;
};
export const formatNextDayTimes = (store, date, orderType) => {
	const nextDay = date.day() == 6 ? 0 : date.day() + 1;
	let nextDayMenus = [];
	let period = null;

	if (orderType == 'collection') {
		period = store && store.order_slot_interval_mins ? store.order_slot_interval_mins : 5;
		nextDayMenus = store.json_time_selector
			?.map((menu) => menu.availability.find((day) => day.d == `w${nextDay}`))
			.filter((menu) => menu?.unavailable_times)
			.map((menu) => ({
				...menu,
				end: menu.unavailable_times[0].start,
			}));
		if (nextDayMenus.length > 0) {
			return generateTimeSlots(nextDayMenus[0].start, nextDayMenus[0].end, period);
		} else {
			return [];
		}
	}
};
export const formatDataForTime = (store, minDate, selectedRestaurant, isCharterDelivery, isTableOrder, snoozedTimes, isScheduledClickCollect, __, isScheduledDelivery) => {
	const timeFormat = 'HH:mm';
	let timesInBetween = [];
	let storeTimes = [];
	const charterDeliveryPeriod = store && store.charter_delivery_order_slot_interval_mins ? store.charter_delivery_order_slot_interval_mins : 30;
	const clickAndCollectPeriod = store && store.order_slot_interval_mins ? store.order_slot_interval_mins : 5;
	const scheduledClickCollectPeriod = store && store?.active_menus?.scheduled_collection ? store?.active_menus?.scheduled_collection?.slot_duration_mins : 5;
	const scheduledDeliveryPeriod = store && store?.active_menus?.scheduled_delivery ? store?.active_menus?.scheduled_delivery?.slot_duration_mins : 5;

	const minDT = minDate.format('HH:mm');
	const date = moment(minDate).tz(getConfig().timezone);
	const dow = 'w' + date.day();
	const period = isScheduledDelivery ? scheduledDeliveryPeriod : isCharterDelivery ? charterDeliveryPeriod : !isScheduledClickCollect ? clickAndCollectPeriod : scheduledClickCollectPeriod;
	let additionalSettings = store && store.additional_delivery_settings ? store.additional_delivery_settings : {};
	if (Basket.getDeliveryOption()) {
		additionalSettings = additionalSettings[Basket.getDeliveryOption().id];
	}
	const collection_minutes = [];
	let minutes = -period;
	while (minutes < 60) {
		minutes += period;
		if (minutes < 60) {
			collection_minutes.push(minutes);
		}
	}
	if (store) {
		if (isScheduledClickCollect) {
			let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
			let today = days[date.day()];
			let slot = store?.active_menus?.scheduled_collection?.slots[today.toLowerCase()];
			if (slot?.start_time) {
				storeTimes.push({
					d: dow,
					start: slot.start_time,
					end: slot.end_time,
				});
			}
		} else if (isScheduledDelivery) {
			let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
			let today = days[date.day()];
			let slot = store?.active_menus?.scheduled_delivery?.slots[today.toLowerCase()];
			if (slot?.start_time) {
				storeTimes.push({
					d: dow,
					start: slot.start_time,
					end: slot.end_time,
				});
			}
		} else {
			parseTimesJson(isCharterDelivery ? store.charter_delivery_times_json : isTableOrder ? store.table_json_time_selector : store.json_time_selector, date).forEach((time) => {
				if (time.d === dow) {
					storeTimes.push({ ...time });
				}
			});
		}
	}

	function makePickerText(times, j, i) {
		let collectionMinutes = parseInt(times[j]) < 10 ? '0' + times[j] : times[j];
		return {
			text: i < 10 ? '0' + i + ':' + collectionMinutes : i + ':' + collectionMinutes,
			value: i < 10 ? '0' + i + ':' + collectionMinutes : i + ':' + collectionMinutes,
		};
	}

	function returnTimesInBetween(start, end, cnt) {
		let startH = parseInt(start.split(':')[0]);
		let startM = parseInt(start.split(':')[1]);
		let endH = parseInt(end.split(':')[0]);
		let endM = parseInt(end.split(':')[1]);
		let minTimeStart = parseInt(minDT.split(':')[0]);
		let minTimeEnd = parseInt(minDT.split(':')[1]);
		let c = collection_minutes.filter((cm) => cm >= startM);
		let cm = collection_minutes.filter((cm) => cm <= endM);
		let startHH = startH;
		if (startHH <= minTimeStart) {
			startHH = minTimeStart;
		}
		if (isScheduledClickCollect || isScheduledDelivery) {
			let _start = moment()
				.hours(parseInt(start.split(':')[0]))
				.minutes(parseInt(start.split(':')[1]))
				.seconds(0);
			let _end = moment()
				.hours(parseInt(end.split(':')[0]))
				.minutes(parseInt(end.split(':')[1]))
				.seconds(0);
			for (let _time = _start; _time.isSameOrBefore(_end); _time.add(period, 'minutes')) {
				timesInBetween.push({
					text: _time.format('HH:mm'),
					value: _time.format('HH:mm'),
				});
			}
		} else {
			for (let i = startHH; i <= endH; i++) {
				if (startH === i) {
					for (let j = 0; j < c.length; j++) {
						if (c[j] >= minTimeEnd && cnt === 0 && startH <= minTimeStart) {
							timesInBetween.push(makePickerText(c, j, i));
						} else if (cnt !== 0) {
							timesInBetween.push(makePickerText(c, j, i));
						} else if (startH > minTimeStart) {
							timesInBetween.push(makePickerText(c, j, i));
						}
					}
				} else if (endH === i) {
					if (minTimeStart === i) {
						for (let j = 0; j < cm.length; j++) {
							if (cm[j] >= minTimeEnd) {
								timesInBetween.push(makePickerText(cm, j, i));
							}
						}
					} else {
						for (let j = 0; j < cm.length; j++) {
							timesInBetween.push(makePickerText(cm, j, i));
						}
					}
				} else {
					if (i === minTimeStart) {
						let collection_m = collection_minutes.filter((cm) => cm >= minTimeEnd);
						for (let j = 0; j < collection_m.length; j++) {
							timesInBetween.push(makePickerText(collection_m, j, i));
						}
					} else {
						for (let j = 0; j < collection_minutes.length; j++) {
							timesInBetween.push(makePickerText(collection_minutes, j, i));
						}
					}
				}
			}
		}

		//if we have no oppning times, just add 'CLOSED' label to the picker
		if (timesInBetween && timesInBetween.length > 1 && timesInBetween[0] && timesInBetween[0].text === 'CLOSED') {
			timesInBetween.shift();
		}
		//if we have no oppning times, just add 'CLOSED' label to the picker
		if (isDefined(store) && timesInBetween.length === 0) {
			timesInBetween.push({ text: 'CLOSED', value: null });
		}
		const storeLocalTime = (time) => moment(moment(time).tz(getConfig().timezone).format(timeFormat), timeFormat);
		let storeWorkingTime = storeTimes && storeTimes[0];
		if (storeTimes.length > 1 && additionalSettings?.asap) {
			storeWorkingTime = storeTimes.filter(({ start, end }) => {
				const startTime = moment(start, timeFormat);
				const endTime = moment(end, timeFormat);
				return storeLocalTime().isBetween(startTime, endTime, null, '[)');
			});
		}
		const asapWorkingTime = isArray(storeWorkingTime) ? storeWorkingTime[0] : storeWorkingTime;
		const hasAsapWorkingTime = isDefined(asapWorkingTime?.start) && isDefined(asapWorkingTime?.end);
		const startTime = hasAsapWorkingTime ? moment(asapWorkingTime.start, timeFormat) : null;
		const endTime = hasAsapWorkingTime ? moment(asapWorkingTime.end, timeFormat) : null;
		if (
			timesInBetween.length > 1 &&
			timesInBetween[0].text !== 'CLOSED' &&
			additionalSettings &&
			((additionalSettings.asap && hasAsapWorkingTime && storeLocalTime(date).isBetween(startTime, endTime)) ||
				(additionalSettings.asap === false && additionalSettings.timePicker === false))
		) {
			timesInBetween[0] = {
				text: 'ASAP',
				value: 'asap',
			};
		} else if (storeWorkingTime.length > 0 && additionalSettings?.asap && timesInBetween.length > 1) {
			timesInBetween[0] = {
				text: 'ASAP',
				value: 'asap',
			};
		}
		if (isCharterDelivery && getConfig().flags.delivery_asap) {
			timesInBetween = [
				{
					text: 'ASAP',
					value: timesInBetween[0].value,
				},
			];
		}

		return timesInBetween;
	}

	storeTimes.forEach((storeT, i, arr) => {
		returnTimesInBetween(storeT.start, storeT.end, i);
		let minH = parseInt(minDT.split(':')[0]);
		let minM = parseInt(minDT.split(':')[1]);
		let endTimeH = parseInt(storeT.end.split(':')[0]);
		let endTimeM = parseInt(storeT.end.split(':')[1]);
		let minTime = date.hours(minH).minutes(minM);
		let timeEnd = date.hours(endTimeH).minutes(endTimeM);
		if (!Basket.getRestaurant()?.enable_past_midnight_orders?.includes(Basket.order_type)) {
			if (i < arr.length - 1 && arr.length > 0 && moment(minTime).tz(getConfig().timezone).isSameOrBefore(timeEnd)) {
				timesInBetween.push({ text: 'CLOSED', value: null });
			}
		}
	});

	//remove 'CLOSED' label if that is first time
	if (timesInBetween && timesInBetween.length > 1 && timesInBetween[0] && timesInBetween[0].text === 'CLOSED') {
		timesInBetween.shift();
	}
	if (timesInBetween.length === 0 && selectedRestaurant) {
		timesInBetween.push({ text: 'CLOSED', value: null });
	}

	return timesInBetween.map((time) => {
		let timeHTML = ''
		if (time.text.toLowerCase() == 'asap') {
			timeHTML = 'ASAP'
		} else if (time.text.toLowerCase() == 'closed') {
			timeHTML = 'CLOSED'
		} else {
			timeHTML = moment(time.text, "HH:mm").format("h:mm a")
		}
		return {
			...time,
			disabled: snoozedTimes.length > 0 && snoozedTimes.includes(time.text),
			html: `<span class='${snoozedTimes.length > 0 && snoozedTimes.includes(time.text) ? 'snoozed' : ''}'>${timeHTML}</span>`,
		}
	});
};

export const isStoreOpened = (selectedRestaurant) => {
	if (selectedRestaurant) {
		const timezone = getConfig().timezone;
		let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		let today = days[moment().tz(getConfig().timezone).day()];
		let currentDay = new Date().getDay();
		if (currentDay === 0) {
			currentDay = 7;
		}
		let label = false;

		const openingTimes = selectedRestaurant.json_opening_time_info.filter((el) => el.day === today)[0];
		if (openingTimes && !Array.isArray(openingTimes.time)) {
			openingTimes.time = [openingTimes.time];
		}

		if (openingTimes && openingTimes?.active !== false) {
			const current = moment().tz(timezone).format('HH:mm')
			for (let i = 0; i < openingTimes.time.length; i++) {
				const openingTimesForToday = openingTimes.time[i].split('-');
				const currentTime = moment(current, 'HH:mm')
				const startTime = moment(openingTimesForToday[0], 'HH:mm');
				const endTime = moment(openingTimesForToday[1], 'HH:mm');

				if (currentTime.isBetween(startTime, endTime, undefined, '[]')) {
					label = true
					break
				} else {
					label = false
				}
			}
		}
		return label;
	}
	else {
		return false
	}
};



class ClickAndCollect extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedRestaurant: props.location.state?.collectionTimeRestaurant
				? props.location.state?.collectionTimeRestaurant
				: props.location.state?.selectedRestaurant
					? props.location.state.selectedRestaurant.restaurant_id
					: null,
			pickTime: null,
			error: '',
			modalOpen: false,
			isSelectedResButtonActive: true,
			continueButtonClicked: false,
			isLocationAllowed: false,
			renderAgain: false,
			showOnlyPickUpText: false,
			resturantIsDisabled: false,
			pickTimeDisplayText: null,
			filterValue: '',
			isSubmitRestaurantAlertOpen: false
		};
	}

	componentDidMount() {
		const searchParams = new URLSearchParams(this.props.location.search);
		try {
			sendToAnalytics('page_view', {
				page_title: this.props.scheduled ? 'Scheduled Click & Collect' : 'Click & Collect',
				page_location: typeof window !== 'undefined' ? window.location?.href : '',
				page_path: this.props.scheduled ? '/click-and-collect-scheduled' : '/click-and-collect',
			});
		} catch (e) { console.log('Error_sending_page_view_analytics', e); }
		if (Basket.getDeliveryOption()?.id === 'gift-vouchers') {
			Basket.reset();
		}
		const { restaurants } = this.props;
		this.props.dispatch(loading(true));
		if (!this.props.auth.loggedIn && !this.props.location?.state?.saveOrderData && getConfig().flags.showGuestUserModalBeforeOrder) {
			this.props.dispatch(setCommonProp('guestUserActionsModalOpen', true));
		}
		this.props.scheduled ? Basket.setOrderType('scheduled-collection') : Basket.setOrderType('collection');
		if (this.props.location.state?.collectionTimeRestaurant) {
			const selectedRestaurant = restaurants.find((restaurant) => restaurant.id === this.state.selectedRestaurant);
			Basket.setRestaurant(selectedRestaurant);
			this.setState({ showTime: true });
		}
		if (this.state.selectedRestaurant) {
			const selectedRestaurant = restaurants.find((restaurant) => restaurant.id === this.state.selectedRestaurant);
			const orderType = getConfig().delivery.filter((el) => el.id === (this.props.scheduled ? 'scheduled-collection' : 'collection'));
			const orderTypeDisabled = orderType[0]?.isRemoved || orderType[0]?.isDisabled;
			if ((this.props.scheduled ? selectedRestaurant.can_scheduled_collection_order : selectedRestaurant.can_collection_order) && selectedRestaurant.is_published && !orderTypeDisabled) {
				Basket.setRestaurant(restaurants.find((restaurant) => restaurant.id === this.state.selectedRestaurant));
				Basket.setServicePercentage(0);
				// Basket.setProcessingFee();
			} else {
				forwardTo('/history', { tab: 'order' });

				this.props.dispatch(showToast(this.props.__('This restaurant is currently not accepting orders'), 'warning'));
				Basket.reset();
			}
		}

		let option = (getConfig().delivery || []).find((d) => d.id === Basket.order_type);
		Basket.setDeliveryOption(option);
		checkForDeliveryOption(Basket.getDeliveryOption(), this.props.scheduled ? '/click-and-collect-scheduled' : '/click-and-collect').then((deliveryOption) => {
			if (deliveryOption) {
				this.props.dispatch(getRestaurants());
				this.props.dispatch(setDeliveryOption(deliveryOption));
				const blId = searchParams.get('bl_id');
				if (blId && !this.state.selectedRestaurant) {
					const selectedRestaurant = this.props.restaurants.find((restaurant) => restaurant.business_location_id === blId);
					const orderTypeConfig = getConfig().delivery.filter((el) => el.id === (this.props.scheduled ? 'scheduled-collection' : 'collection'));
					const orderTypeDisabled = orderTypeConfig[0]?.isRemoved || orderTypeConfig[0]?.isDisabled;
					const canOrder = this.props.scheduled ? selectedRestaurant?.can_scheduled_collection_order : selectedRestaurant?.can_collection_order;
					if (canOrder && selectedRestaurant.is_published && !orderTypeDisabled) {
						this.selectRestaurant(selectedRestaurant.id);
					} else {
						this.props.dispatch(showToast(this.props.__('Restaurant you selected is not available'), 'warning'));
					}
				} else {
					this.haveOnePublishedResturant();
				}
			}
			if (Basket.getMenu()) {
				this.setState({ selectedIkentooMenu: Basket.getMenu() });
			}
			this.props.dispatch(loading(false));
		});
		this.position();
	}
	selectRestaurant = (selectedRestaurantId) => {
		const { restaurants, profile } = this.props;
		const pickTime = moment.unix(Basket.collection_time).tz(getConfig().timezone).format('HH:mm');

		if (this.props.location?.state?.saveOrderData && Basket.has_multi_basket) {
			this.setState({ selectedRestaurant: selectedRestaurantId, pickTime }, () => {
				const restaurant = restaurants.find((restaurant) => restaurant.id === selectedRestaurantId);
				Basket.setRestaurant(restaurant);
				Basket.setCuratedMenu(false);
				this.chooseMenusForLocation();
			});
		} else {
			this.setState({ selectedRestaurant: selectedRestaurantId, pickTime: null, showTime: true }, () => {
				const restaurant = restaurants.find((restaurant) => restaurant.id === selectedRestaurantId);
				let additionalSettings = restaurant && restaurant.additional_delivery_settings ? restaurant.additional_delivery_settings : {};
				additionalSettings = additionalSettings[this.props.deliveryOption?.id];
				if (!this.props.location?.state?.saveBasket) {
					Basket.reset(profile.cardToken);
				}
				Basket.setRestaurant(restaurant);
				if (!this.props.location?.state?.saveOrderData) {
					if (getConfig().general.hasServiceCharge && getConfig().general.service_charge_modules?.includes(this.props.scheduled ? 'scheduled-collection' : 'collection')) {
						if (getConfig().flags.applyAutomaticServiceCharge) {
							if (Basket.getRestaurantServiceCharge()) {
								const service_charge_original = Basket.getRestaurantServiceCharge();
								Basket.setServicePercentage(Number((service_charge_original[1] * 100).toFixed(2)));
							} else {
								const defaultServiceCharge = typeof getConfig().general.defaultServiceCharge == 'string' ? JSON.stringify(getConfig().general.defaultServiceCharge) : getConfig().general.defaultServiceCharge;;
								if (defaultServiceCharge) {
									Basket.setServicePercentage(Number((defaultServiceCharge[1] * 100).toFixed(2)));
								}
							}
						} else {
							Basket.setServicePercentage(0);
						}
					} else {
						Basket.setServicePercentage(0);
					}
				}
				if (!this.props.scheduled) {
					Basket.setCollectionTime(null);
				}
				Basket.setDeliveryOption(this.props.deliveryOption);
				this.props.scheduled ? Basket.setOrderType('scheduled-collection') : Basket.setOrderType('collection');
				if (this.state.pickTimeDisplayText) {
					Basket.setNamedTimeSlotsData(this.state.pickTimeDisplayText);
				}
				if (additionalSettings && additionalSettings.asap === false && additionalSettings.timePicker === false) {
					const hasPickUpText = additionalSettings?.hasPickUpText;
					this.props.dispatch(loading(true));
					let now = moment();
					if (restaurant && isDefined(restaurant.order_slot_lead_time) && shouldAddPrepTime()) {
						now.add(restaurant.order_slot_lead_time, 'minutes');
					}
					Basket.setASAP(true);
					Basket.setCollectionTime(now);
					this.setState({ selectedTime: 'asap', pickTime: 'asap', showOnlyPickUpText: hasPickUpText }, () => {
						if (!hasPickUpText) {
							this.chooseMenusForLocation();
						}
						this.props.dispatch(loading(false));
					});
				} else {
					this.props.dispatch(loading(false));
				}
			});
		}
	};

	changeTime = (selectedTime, minDT) => {
		if (selectedTime && minDT) {
			if (this.timePickerOptions.find((el) => el.text == selectedTime)?.isNextDay) {
				minDT.add('days', 1);
				this.setState({ isNextDay: true });
			} else {
				this.setState({ isNextDay: false });
			}
			let h = parseInt(selectedTime.split(':')[0]);
			let m = parseInt(selectedTime.split(':')[1]);
			const formattedDT = moment(minDT).hours(h).minutes(m);
			let newPickTime = selectedTime;
			if (selectedTime === 'asap') {
				newPickTime = formattedDT.format('HH:mm');
			}
			this.setState({ pickTime: newPickTime }, () => {
				Basket.setCollectionTime(formattedDT);
				Basket.setOrderType('collection');
				Basket.setASAP(selectedTime === 'asap');
			});
		} else {
			this.setState({ pickTime: null });
		}
	};

	shouldComponentUpdate(nextProps, nextState) {
		if (
			nextState.pickTime !== this.state.pickTime ||
			nextProps.restaurants !== this.props.restaurants ||
			nextState.selectedRestaurant !== this.state.selectedRestaurant ||
			nextProps.isChooseMenuModalOpen !== this.props.isChooseMenuModalOpen ||
			nextState.showTime !== this.state.showTime ||
			nextState.continueButtonClicked !== this.state.continueButtonClicked ||
			nextState.isLocationAllowed !== this.state.isLocationAllowed ||
			nextState.renderAgain !== this.state.renderAgain ||
			nextProps.continueScheduleOrdering !== this.props.continueScheduleOrdering ||
			nextState.filterValue !== this.state.filterValue ||
			nextState.isSubmitRestaurantAlertOpen !== this.state.isSubmitRestaurantAlertOpen

		) {
			return true;
		} else {
			return false;
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.isLocationAllowed !== prevState.isLocationAllowed) {
			// skipLoading, otherwise the spinner swaps out the whole screen and remounts the time picker
			this.props.dispatch(getRestaurants({ skipLoading: true }));
		}
		if (this.props.continueScheduleOrdering !== prevProps.continueScheduleOrdering && this.state.timeSelected && this.props.scheduled) {
			this.setState({ timeSelected: false })
		}

		checkForDeliveryOption(Basket.getDeliveryOption(), this.props.scheduled ? '/click-and-collect-scheduled' : '/click-and-collect').then(() => {
			if (this.props.ikentooMenusForLocation.length !== prevProps.ikentooMenusForLocation.length) {
				if (this.props.ikentooMenusForLocation[0]) {
					this.setState({
						selectedIkentooMenu: this.props.ikentooMenusForLocation[0].ikentooMenuId,
					});
				}
			}
		});
	}
	/* selectStore = (store, e) => {
		if (e.target.checked) {
			this.setState({ selectedRestaurant: store.id });
		} else {
			this.setState({ selectedRestaurant: null });
		}
	}; */
	selectStore = (store) => {
		this.setState({ selectedRestaurant: store.id, renderAgain: !this.state.renderAgain });
	};
	setPickTime = (inst, minDT) => {
		if (inst && inst.getVal()) {
			this.changeTime(inst.getVal(), minDT);
		} else {
			this.setState({ pickTime: null });
		}
	};

	continueOnMenu = () => {
		const { restaurants, dispatch } = this.props;
		const { selectedIkentooMenu, selectedRestaurant } = this.state;
		if (selectedRestaurant && selectedIkentooMenu) {
			const choosenRestaurant = restaurants.find((restaurant) => restaurant.id === selectedRestaurant);
			const businessLocationId = choosenRestaurant.business_location_id;
			dispatch(getIkentooMenu(selectedIkentooMenu, businessLocationId, true, this.props.scheduled ? 'scheduled_collection' : 'collection'));
		} else {
			this.setState({ error: 'Please select location menu' });
		}
	};

	getMenuForReorder = (menus, reorderItems) => {
		let menuForReorder = [];
		for (let i = 0; i < menus.length; i++) {
			let foundItems = 0;
			const categoryItems = menus[i].menuEntry || menus[i].menuEntryGroups || null;
			let items = Basket.flattenMenuItems(deepCopy(categoryItems));
			menus[i].flattenMenuItems = items;
			if (items.length > 0) {
				for (let j = 0; j < reorderItems.length; j++) {
					let foundItem = items.find((i) => i.sku === reorderItems[j].item.sku);
					if (foundItem) {
						foundItems = foundItems + 1;
					}
				}
			}
			menus[i].foundItems = foundItems;
			menuForReorder.push(menus[i]);
		}
		menuForReorder.sort((a, b) => b.foundItems - a.foundItems);
		if (menuForReorder[0] && menuForReorder[0].foundItems > 0) {
			return filterMenu(menuForReorder[0]);
		} else {
			return false;
		}
	};
	changeCollectionTime = async () => {
		this.props.dispatch(loading(true));

		const restaurant = this.props.restaurants.find((el) => el.id == Basket.getRestaurant().id);
		let ikentooMenusForLocation = await api.getIkentooMenusForLocation(restaurant.business_location_id);
		if (this.props.scheduled) {
			const scheduledMenuId = restaurant.active_menus?.scheduled_collection?.menu_id;
			ikentooMenusForLocation = ikentooMenusForLocation.filter((menu) => menu.ikentooMenuId == scheduledMenuId);
		} else {
			ikentooMenusForLocation = getMenusForSelectedTime(ikentooMenusForLocation, this.state.pickTime, restaurant.json_time_selector);
		}
		let availableMenu = false

		if (this.props.location.state?.saveBasket) {
			availableMenu = ikentooMenusForLocation.length > 0 ? ikentooMenusForLocation[0] : false
		} else {
			availableMenu = ikentooMenusForLocation.find((el) => el.ikentooMenuId == Basket.getMenu());
		}
		if (!availableMenu) {
			this.setState({ showTime: false }, () => {
				Basket.reset();
				this.props.dispatch(showToast('Menu is no longer available', 'warning'));
			});
			this.props.dispatch(loading(false));

		} else {
			Basket.setMenu(availableMenu.ikentooMenuId)
			const menu = await api.getIkenooMenu(availableMenu.ikentooMenuId, restaurant.business_location_id, this.props.scheduled ? 'scheduled_collection' : 'collection');
			if (menu) {
				this.props.dispatch({
					type: SET_RESTAURANT_PROP,
					key: 'ikentooMenu',
					value: menu,
				});
				const basketItems = Basket.getItems();
				const categoryItems = menu.menuEntry || menu.menuEntryGroups || null;
				let menuItems = Basket.flattenMenuItems(deepCopy(categoryItems));
				for (let i = basketItems.length - 1; i >= 0; i--) {
					if (!menuItems.find((el) => el.sku == basketItems[i].item.sku) || !Basket.isProductEnabled(basketItems[i].item)) {
						Basket.removeFromBasket(i);
					}
				}
				if (basketItems.length !== Basket.getItems().length) {
					this.props.dispatch(showToast('Some items were not added to your basket as they are currently unavailable', 'warning'));
				}
				this.props.dispatch(loading(false));

				forwardTo('/order');

			} else {
				this.props.dispatch(showToast('Menu not found', 'warning'));
			}
		}

	};
	chooseMenusForLocation = async () => {
		if (this.props.location.state?.collectionTimeRestaurant || this.props.location.state?.saveBasket) {
			await this.changeCollectionTime();
		} else {
			const { restaurants, dispatch } = this.props;
			const { selectedRestaurant, pickTime } = this.state;
			this.setState({ continueButtonClicked: true }, async () => {
				if (selectedRestaurant && pickTime) {
					const choosenRestaurant = restaurants.find((restaurant) => restaurant.id === selectedRestaurant);
					const businessLocationId = choosenRestaurant.business_location_id;
					let currentDT = moment().tz(getConfig().timezone);
					// Basket.setOrderStartingTime(currentDT.unix())
					if (this.state.isNextDay) {
						currentDT.add(1, 'days');
					}
					let h = parseInt(pickTime.split(':')[0]);
					let m = parseInt(pickTime.split(':')[1]);
					const formattedDT = moment(currentDT).hours(h).minutes(m);
					const cutoffTime = moment(formattedDT);
					if (choosenRestaurant?.order_slot_lead_time && shouldAddPrepTime()) {
						cutoffTime.subtract(parseInt(choosenRestaurant.order_slot_lead_time), 'minutes');
					}
					if (!this.props.scheduled) {
						Basket.setCutoffTime(cutoffTime.unix());
						Basket.setCollectionTime(formattedDT);
					}
					if (this.props.scheduled) {
						this.setState({ timeSelected: true });
						this.props.dispatch({ type: SET_RESTAURANT_PROP, key: 'continueScheduleOrdering', value: false })
					}
					if (this.props.location.state && this.props.location.state.selectedRestaurant) {
						this.props.dispatch(loading(true))

						let ikentooMenusForLocation = await api.getIkentooMenusForLocation(businessLocationId);
						if (this.props.scheduled) {
							const scheduledMenuId = choosenRestaurant.active_menus?.scheduled_collection?.menu_id;
							ikentooMenusForLocation = ikentooMenusForLocation.filter((menu) => menu.ikentooMenuId == scheduledMenuId);
						} else {
							ikentooMenusForLocation = getMenusForSelectedTime(ikentooMenusForLocation, pickTime, choosenRestaurant.json_time_selector);
						}
						if (ikentooMenusForLocation && isObject(ikentooMenusForLocation[0])) {
							let ikentooMenus = [];
							try {
								for (let i = 0; i < ikentooMenusForLocation.length; i++) {
									ikentooMenus.push(await api.getIkenooMenu(ikentooMenusForLocation[i].ikentooMenuId, businessLocationId, this.props.scheduled ? 'scheduled_collection' : 'collection'));
								}
							} catch (error) {
								this.setState({ error: 'Get restaurant menu error.' });
								this.setState({ continueButtonClicked: false });
								this.props.dispatch(loading(false))

							}
							const reorderItems = this.props.location.state.selectedRestaurant.items;
							const menu = this.getMenuForReorder(ikentooMenus, reorderItems);
							if (menu) {

								dispatch({
									type: SET_RESTAURANT_PROP,
									key: 'ikentooMenu',
									value: menu,
								});
								if (menu.flattenMenuItems.length > 0) {
									let validationStatus = {
										notBasketEmpty: false,
										validationError: false,
									};
									reorderItems.map((newBasketItem) => {
										let foundItem = menu.flattenMenuItems.find((i) => i.sku === newBasketItem.item.sku);
										if (foundItem && Basket.isProductEnabled(foundItem)) {
											if (newBasketItem?.selectedChoices?.length > 0) {
												newBasketItem.selectedChoices = Basket.filterReorderChoices(newBasketItem.selectedChoices, foundItem);
											}
											newBasketItem.item = foundItem;
											Basket.addToBasket(newBasketItem);
											let item = newBasketItem.item;
											let allergens = this.props.allergens;
											let profile = this.props.profile;
											let newArr = parseAllergenData(profile, item, allergens);
											let allergensCodes = newBasketItem.item?.itemRichData?.allergenCodes.length > 0 ? newBasketItem.item.itemRichData.allergenCodes : [];
											if (allergensCodes.length > 0) {
												let allergensData = [{ allergens: newArr }, { sku: newBasketItem.item.sku }];
												Basket.setAllergen(allergensData);
											}
											validationStatus.notBasketEmpty = true;
										} else {
											validationStatus.validationError = true;
										}
									});
									if (validationStatus.notBasketEmpty) {
										if (validationStatus.validationError) {
											dispatch(showToast('Some items were not added to your basket as they are currently unavailable', 'warning'));
											this.setState({ continueButtonClicked: false });
										}
										forwardTo('/order-summary', {
											skipBackToThePreviousPage: false,
											stopLoading: true
										});
									} else {
										dispatch(showToast('Some items were not added to your basket as they are currently unavailable', 'warning'));
										this.setState({ continueButtonClicked: false });
										this.props.dispatch(loading(false))

									}
								} else {
									dispatch(showToast('Menu not found', 'warning'));
									this.setState({ continueButtonClicked: false });
									this.props.dispatch(loading(false))
								}
							} else {
								dispatch(showToast('Menu not found', 'warning'));
								this.setState({ continueButtonClicked: false });
								this.props.dispatch(loading(false))
							}
						} else {
							dispatch(showToast('Menu not found', 'warning'));
							this.setState({ continueButtonClicked: false });
							this.props.dispatch(loading(false))

						}
					} else {
						dispatch(
							getIkentooMenusForLocation(businessLocationId, {
								isNextDay: this.state.isNextDay,
								pickTime,
								json_time_selector: choosenRestaurant
									? this.props.scheduled && choosenRestaurant?.active_menus?.scheduled_collection
										? [
											{
												menuId: choosenRestaurant?.active_menus.scheduled_collection?.menu_id,
												availability: Object.keys(choosenRestaurant?.active_menus.scheduled_collection?.slots).map((slot) => {
													if (choosenRestaurant?.active_menus.scheduled_collection?.slots[slot].start_time) {
														return {
															d: weekdays[slot],
															start: choosenRestaurant?.active_menus.scheduled_collection?.slots[slot].start_time,
															end: choosenRestaurant?.active_menus.scheduled_collection?.slots[slot].end_time,
														};
													}
												}),
											},
										]
										: choosenRestaurant.json_time_selector
									: [],
							}),
						);
						this.setState({ continueButtonClicked: false });
					}
				} else if (!selectedRestaurant) {
					this.setState({ error: 'Please select location' });
				} else {
					this.setState({ error: 'Please select pickup time' });
				}
			});
		}
	}

	changeIkentooMenus = (event) =>
		this.setState({ selectedIkentooMenu: event.detail.value, error: '' }, () => {
			Basket.setMenu(event.detail.value);
		});

	position = async () => {
		try {
			if (isNative()) {
				const coordinates = await Geolocation.getCurrentPosition({
					enableHighAccuracy: true
				});

				this.props.dispatch(
					setMyLocation({
						latitude: coordinates.coords.latitude,
						longitude: coordinates.coords.longitude,
					}),
				);
				this.setState({
					isLocationAllowed: true,
				});
			} else {
				/* eslint-disable */
				navigator.geolocation.getCurrentPosition(
					(res) => {
						this.props.dispatch(
							setMyLocation({
								latitude: res?.coords?.latitude,
								longitude: res?.coords?.longitude,
							}),
						);
						this.setState({
							isLocationAllowed: true,
						});
					},
					() => {
						this.setState(
							{
								isLocationAllowed: false,
							},
							() => {
								this.props.dispatch(setMyLocation({ latitude: null, longitude: null }));
							},
						);
					},
				);
				/* eslint-enable */
			}
		} catch (error) {
			console.log('Location error:', error);
			this.setState(
				{
					isLocationAllowed: false,
				},
				() => {
					this.props.dispatch(setMyLocation({ latitude: null, longitude: null }));
				},
			);
		}
	};

	formatDataForSelect = (stores) => {
		let formatedStores = [];
		stores.forEach((store) => {
			let currentDT = null;
			if (Basket.has_multi_basket && this.props.location?.state?.saveOrderData) {
				currentDT = moment.unix(Basket.collection_time).tz(getConfig().timezone);
			} else {
				currentDT = moment().tz(getConfig().timezone);
			}
			let minDT = currentDT;
			if (!this.props.location?.state?.saveOrderData) {
				if (store && isDefined(store.order_slot_lead_time) && shouldAddPrepTime()) {
					minDT.add(store.order_slot_lead_time, 'minutes');
				}
			}
			const snoozedTimes = checkSnoozedTimes(store, this.props.scheduled ? 'scheduled-collection' : 'collection');
			const storeOpened = store.can_scheduled_collection_order && Basket.getDeliveryOption()?.id === 'scheduled-collection' ? true : isStoreOpened(store);
			let slotsAvailable = true;
			if (!this.props.scheduled) {
				let additionalSettings = store && store.additional_delivery_settings ? store.additional_delivery_settings : {};
				additionalSettings = additionalSettings[Basket.getDeliveryOption()?.id];
				if (additionalSettings && additionalSettings?.asap === false && additionalSettings?.timePicker === false) {
					slotsAvailable = isTimeAvaibleInMenu(store.json_time_selector, currentDT);
				} else {
					const timeData = formatDataForTime(store, minDT, store.id, false, false, snoozedTimes, this.props.scheduled);
					slotsAvailable = timeData.length === 1 && timeData[0].text.toLowerCase() === 'closed' ? false : true;
					if (this.props.location?.state?.saveOrderData) {
						slotsAvailable =
							timeData.length === 1 && timeData[0].text.toLowerCase() === 'closed'
								? false
								: timeData[0].value.toLowerCase() == 'asap'
									? true
									: moment(moment(minDT).format('HH:mm'), 'HH:mm').isSameOrAfter(moment(timeData[0].value, 'HH:mm'));
					}
				}
			}
			store.opened = slotsAvailable;

			if (storeOpened && slotsAvailable) {
				store.openLabel = 'Open';
			} else if (storeOpened && !slotsAvailable) {
				store.openLabel = 'Unavailable';
			} else if (!storeOpened && slotsAvailable) {
				store.openLabel = 'Preorder';
			} else if (!storeOpened && !slotsAvailable) {
				store.openLabel = 'Closed';
			}
			if (this.props.scheduled) {
				if (isDefined(store.can_scheduled_collection_order) && isDefined(store.is_published)) {
					if (store.can_scheduled_collection_order && store.is_published) {
						formatedStores.push(store);
					}
				}
			} else if (store.is_published && store.can_collection_order) {
				formatedStores.push(store);
			}
		});
		return formatedStores;
	};

	parseSelectedTime(selected) {
		let selectedTimeSlot = selected.match(/\d{1,2}:\d{2} (AM|PM)/)?.[0] || 'CLOSED';
		const selectedDate = selected.replace(' ' + selectedTimeSlot, '');
		const timePickerOptionsKeys = Object.keys(this.timePickerOptions);
		const selectedTime =
			selectedDate === 'init'
				? this.timePickerOptions && timePickerOptionsKeys.length > 0
					? this.timePickerOptions[timePickerOptionsKeys[0]][0]
					: {}
				: this.timePickerOptions[selectedDate].find((option) => option.time === selectedTimeSlot);
		if (selectedTime && !isEmptyObject(selectedTime) && selectedTime.time?.toLowerCase() !== 'closed' && !this.state.timeSelected) {
			this.setState({ pickTime: selectedTime?.snoozed ? null : selectedTime.slot }, () => {
				let days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
				const dayName = days[selectedTime.formattedDT.day()];
				const slot = Basket.restaurant?.active_menus?.scheduled_collection?.slots[dayName];
				if (slot) {
					const splitedStartTime = slot.start_time.split(':');
					const cutoffTime = moment(selectedTime.formattedDT);
					cutoffTime.set('hour', splitedStartTime[0]);
					cutoffTime.set('minute', splitedStartTime[1]);
					if (slot?.prep_time) {
						cutoffTime.subtract(parseInt(slot.prep_time), 'hours');
					}
					Basket.setCutoffTime(cutoffTime.unix());
					Basket.setCollectionTime(selectedTime.formattedDT);
					Basket.setOrderType(this.props.deliveryOption && this.props.deliveryOption.id ? this.props.deliveryOption.id : 'collection');
				}
			});
			if (Basket.restaurant?.named_time_slots_mode) {
				this.setState({ pickTimeDisplayText: selectedTime.displayText }, () => {
					Basket.setNamedTimeSlotsData(selectedTime.displayText);
				});
			}
		}
	}

	formatTimesForTree = (times) => {
		const groupByMonth = groupBy(['date']);
		const grouped = groupByMonth(times);
		return grouped;
	};

	formatPickupTimes = (store) => {
		const formatSelectOptionDays = [];
		const daysAhead = (this.props.scheduled ? store?.active_menus?.scheduled_collection?.days_ahead + 1 || 8 : getConfig().general.collectAheadDays) || 7;
		let picker = [];
		const timezone = getConfig().timezone;
		Array(daysAhead)
			.fill('')
			.forEach((day, i) => {
				let formatDay = moment().tz(timezone).add(i, 'days');
				if (i > 0) {
					formatDay = moment().tz(timezone).add(i, 'days').set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
				}

				if (this.props.scheduled) {
					formatDay = moment().tz(timezone).add(i, 'days').set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
				}
				let days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

				let formatDayName = days[formatDay.day()];
				formatSelectOptionDays.push({ formatDayName, formattedDT: formatDay });
			});
		formatSelectOptionDays.map((option) => {
			const snoozedTimes = store?.snoozed_times['scheduled-collection'] || [];
			let daySlot = [];
			if (store?.named_time_slots_mode && !isEmptyObject(store?.named_time_slots_data_json)) {
				let days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
				const dayName = days[moment(option.formattedDT).tz(getConfig().timezone).day()];
				daySlot = store?.named_time_slots_data_json[dayName]?.map((el) => ({ text: el.value, value: el.value, displayText: el.text })) || [];
			} else {
				daySlot = formatDataForTime(store, option.formattedDT, this.state.selectedRestaurant, false, false, snoozedTimes, this.props.scheduled, this.props.__) || [];
			}
			daySlot.forEach((slot) => {
				let h = parseInt(slot.text.split(':')[0]);
				let m = parseInt(slot.text.split(':')[1]);
				let formattedDT = moment(option.formattedDT.hours(h).minutes(m));

				picker.push({
					formattedDT: formattedDT,
					date: formattedDT.format('ddd, DD MMM'),
					time: formattedDT.format('h:mm A'),
					slot: slot.text,
					displayText: slot.displayText || slot.text,
				});
			});
		});
		let unavailable_dates = null;
		if (this.props.scheduled && store?.active_menus?.scheduled_collection && store?.active_menus?.scheduled_collection?.unavailable_dates) {
			unavailable_dates = store?.active_menus?.scheduled_collection?.unavailable_dates?.map((slot) => moment(slot, 'DD/MM/YYYY').format('ddd, DD MMM'));
		}

		const formattedTreeDataSource = this.formatTimesForTree(picker);
		Object.keys(formattedTreeDataSource).map((day) => {
			if (formattedTreeDataSource[day][0].slot === 'CLOSED') {
				if (this.props.scheduled) {
					delete formattedTreeDataSource[day];
				} else {
					formattedTreeDataSource[day][0] = { time: 'CLOSED' };
				}
			} else {
				if (unavailable_dates && unavailable_dates.length > 0 && unavailable_dates.indexOf(day) > -1) {
					formattedTreeDataSource[day] = [{ time: 'CLOSED' }];
				}
				const d = moment(day, 'ddd, DD MMM').day();
				let days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

				let slot = store?.active_menus?.scheduled_collection?.slots[days[d]];
				if (slot?.start_time && this.props.scheduled && store?.active_menus?.scheduled_collection) {
					let cutoff_time = moment(day, 'ddd, DD MMM')
						.hours(parseInt(slot.start_time.split(':')[0]))
						.minutes(parseInt(slot.start_time.split(':')[1]))
						.seconds(0)
						.add(-slot.prep_time, 'hours');
					if (moment().tz(timezone).isAfter(cutoff_time)) {
						delete formattedTreeDataSource[day];
					}
				}
			}
		});
		const snoozedTimes = store?.snoozed_times['scheduled-collection'] || [];
		snoozedTimes.map((snoozeTime) => {
			let _snoozeTime = moment.utc(snoozeTime, 'ddd, DD MMM YYYY-HH:mm').local();
			let temp_data = formattedTreeDataSource[_snoozeTime.format('ddd, DD MMM')];
			let pos = temp_data?.findIndex((item) => item.slot === _snoozeTime.format('HH:mm'));
			if (pos > -1) {
				temp_data[pos] = { ...temp_data[pos], snoozed: true };
			}
		});
		this.timePickerOptions = formattedTreeDataSource;
	};

	getTitle = (deliveryOption) => {
		if (!deliveryOption) {
			return '';
		} else {
			return deliveryOption.label + ' Order';
		}
	};

	refreshTimeSlot = () => {
		if (this.timeSlotRef.current) {
			this.timeSlotRef.current.instance.init();
		}
	};

	haveOnePublishedResturant = () => {
		const { __, scheduled } = this.props;
		const restaurantArr = this.props.restaurants.filter(
			(restaurant) => restaurant.is_published === true && (scheduled ? restaurant.can_scheduled_collection_order : restaurant.can_collection_order) === true,
		);
		if (restaurantArr.length === 1 && this.state.selectedRestaurant === null && restaurantArr[0].opened) {
			const restaurant = restaurantArr[0];
			const additional_delivery_settings = restaurant.additional_delivery_settings || {};
			const additionalSettings = additional_delivery_settings[this.props.deliveryOption?.id] || {};
			if (additionalSettings?.asap === false && additionalSettings.timePicker === false && !isStoreOpened(restaurant)) {
				this.setState({ resturantIsDisabled: true });
			} else {
				this.selectRestaurant(restaurant.id);
				this.setState({ isSelectedResButtonActive: false });
			}
		}
	};

	handleModalDismissed = () => this.setState({ isSlotReservedModalOpen: false });
	backHandler = () => {
		if (this.state.showTime) {
			this.setState({ showTime: false });
		} else {
			goBack();
		}
	};
	scheduledCollectionOnMultiVenueDisabled = (store) => {
		if (Basket.has_multi_basket && this.props.location?.state?.saveOrderData && this.props.scheduled) {
			const collectionTime = moment.unix(Basket.collection_time).tz(getConfig().timezone).format('DD/MM/YYYY');
			const daysAhead = store?.active_menus?.scheduled_collection?.days_ahead + 1 || 8;
			const timezone = getConfig().timezone;
			const unavailableDates = store?.active_menus?.scheduled_collection?.unavailable_dates?.map((slot) => moment(slot, 'DD/MM/YYYY').format('DD/MM/YYYY')) ?? [];
			const futureDays = Array(daysAhead)
				.fill('')
				.map((day, i) => moment().tz(timezone).add(i, 'days').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format('DD/MM/YYYY'))
				.filter((day) => !unavailableDates.includes(day));
			if (!futureDays.includes(collectionTime)) {
				return true;
			} else {
				const collectionDate = moment.unix(Basket.collection_time).tz(getConfig().timezone).format('d');
				let days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
				const dayName = days[collectionDate];
				const slots = store?.active_menus?.scheduled_collection.slots[dayName];
				const collectionHour = moment.unix(Basket.collection_time).tz(getConfig().timezone).format('HH:mm');
				if (!slots) {
					return true;
				}
				return !isTimeInRange(collectionHour, slots.start_time, slots.end_time);
			}
		} else {
			return false;
		}
	};

	getRestautantDataMessage = (id) => {
		const restaurant = this.props.restaurants.filter((restaurant) => restaurant.id === id);
		return `<p><b>${restaurant[0]?.name}</b></p> \n <p>${restaurant[0]?.address}</p>`;
	};
	isRestaurantOpenForReorder = (stores, restaurant) => {
		if (this.props.location?.state?.reorder) {
			const selectedRestaurant = stores.find(el => el.id == restaurant)
			if (selectedRestaurant) {
				return !selectedRestaurant.opened
			} else {
				return true
			}
		} else {
			return false
		}
	}
	render() {
		const { __, restaurants, ikentooMenusForLocation, isChooseMenuModalOpen, deliveryOption } = this.props;
		const { error, selectedRestaurant, pickTime, selectedIkentooMenu, showTime, showOnlyPickUpText, resturantIsDisabled, filterValue } = this.state;
		const animationMenuClass = isChooseMenuModalOpen ? 'show-up' : '';
		const store = restaurants.find((restaurant) => restaurant.id === selectedRestaurant) || null;
		const stores = restaurants || [];

		const snoozedTimes = checkSnoozedTimes(store, 'collection');

		const currentDT = moment().tz(getConfig().timezone);

		// const timeFormat = 'HH:mm'

		// Added period to prevent time in past 12:51 = 12:55 should be possible to select (min time)
		let minDT = currentDT;
		const restaurantOpeningTime = getRestaurantOpeningTime(store, minDT);
		const restaurantIsOpen = store?.enable_past_midnight_orders?.includes(Basket.order_type) ? true : restaurantOpeningTime?.is_open;
		this.timePickerOptions = [{ text: 'CLOSED', value: null }];
		if (store && (restaurantIsOpen || this.props.scheduled)) {
			if (!store?.enable_past_midnight_orders?.includes(Basket.order_type)) {
				if (restaurantOpeningTime && restaurantOpeningTime.open_at > moment()) {
					minDT = restaurantOpeningTime.open_at;
				}
			}
			//include 'Order slot lead time' from the BO
			if (!this.props.scheduled && store && isDefined(store.order_slot_lead_time) && shouldAddPrepTime()) {
				minDT.add(store.order_slot_lead_time, 'minutes');
			}
			this.timePickerOptions = uniqueByProperty(formatDataForTime(store, minDT, selectedRestaurant, false, false, snoozedTimes, this.props.scheduled, __), 'value');
			if (this.props.scheduled) {
				this.formatPickupTimes(store);
			}

			if (store?.enable_past_midnight_orders?.includes(Basket.order_type)) {
				const today = minDT.day();
				const menus = store.json_time_selector
					?.map((menu) => menu.availability.find((day) => day.d == `w${today + 1}`))
					.filter((menu) => menu?.unavailable_times && menu?.unavailable_times?.length > 0)
					.map((menu) => ({
						...menu,
						end: menu.unavailable_times[0].start,
					}));
				menus.sort((a, b) => moment(b.end, 'HH:mm') - moment(a.end, 'HH:mm'));
				if (menus.length > 0) {
					let currentTime = moment(minDT.format('HH:mm'), 'HH:mm');
					let endMenuTime = moment(menus[0].end, 'HH:mm');
					if (!currentTime.isBefore(endMenuTime)) {
						this.timePickerOptions.push(...formatNextDayTimes(store, minDT, 'collection'));
					}
				}
			}
		}
		const menus = getMenusForSelectedTime(
			ikentooMenusForLocation,
			pickTime,
			store
				? this.props.scheduled && store?.active_menus?.scheduled_collection
					? [
						{
							menuId: store?.active_menus?.scheduled_collection?.menu_id,
							availability: Object.keys(store?.active_menus?.scheduled_collection?.slots).map((slot) => {
								if (store?.active_menus?.scheduled_collection?.slots[slot].start_time) {
									return {
										d: weekdays[slot],
										start: store?.active_menus?.scheduled_collection?.slots[slot].start_time,
										end: store?.active_menus?.scheduled_collection?.slots[slot].end_time,
									};
								}
							}),
						},
					]
					: store.json_time_selector
				: [],
		);
		let formatedStores = this.formatDataForSelect(stores);
		const orderType = Basket.getDeliveryOption()?.id;
		let additionalSettings = store && store.additional_delivery_settings ? store.additional_delivery_settings : {};
		additionalSettings = additionalSettings[orderType];
		const hasPickUpText = additionalSettings?.hasPickUpText;
		const pickUpText = additionalSettings?.pickUpText;

		if (Basket.has_multi_basket && getConfig().flags.geolocationDisabled) {
			const stores = deepCopy(formatedStores);
			let openedRestaurants = stores.filter((store) => store.opened);
			let closedRestaurants = stores.filter((store) => !store.opened);
			openedRestaurants.sort((a, b) => {
				return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
			});
			openedRestaurants.sort((a, b) => a.sort_order - b.sort_order);
			closedRestaurants.sort((a, b) => {
				return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
			});
			closedRestaurants.sort((a, b) => a.sort_order - b.sort_order);
			formatedStores = [...openedRestaurants, ...closedRestaurants];
		}
		const filteredRestaurants = formatedStores.filter(r =>
			r.name.toLowerCase().includes(filterValue.toLowerCase())
		);

		return (
			<Loading>
				<Layout
					showLoginIcon={getConfig().flags.hasGuestCheckout && Basket.itemsCount() == 0}
					showHamburger={!this.state.showTime}
					backHandler={this.backHandler}
					title={__('Click & collect order')}
					headerWithTitle={true}
					color="transparent"
					scrollY={false}
				>
					<div className={`${showTime || getConfig().general.tiledRestaurantView ? 'scrollable-y' : 'flex-row-wrapper'} absolute-content collection-wrapper box-with-shadow`}>
						{!showTime ? (
							<>
								{filteredRestaurants?.length > 0 || filterValue !== '' ? <>
									<Title className="web-only page-title-centered">{this.props.scheduled ? __('Scheduled click & collect order') : __('Click & collect order')}</Title>
									<StrongText className='block text-to-update page-title-centered'>{__('Select a restaurant to collect your order')}</StrongText>
									<Spacer size={2} />
									{!this.props.myLocation.latitude && getConfig().flags.hasDisabledLocationRestaurantsFilter &&
										<div className='restaurants-filter-wrapper'>
											<div className='box-content restaurants-filter-box'>
												<LocationDisabledIcon />

												<div>
													<SmallText className='bold'>{__('Location services unavailable')}</SmallText>
													<SmallText>{__('Please select your nearest store manually.')}</SmallText>

												</div>
											</div>
											<Spacer size={2} />
											<IonItem className='input-field-wrapper' lines='none'>
												<IonInput
													onIonInput={(e) => this.setState({ filterValue: e.target.value })}
													type="text"
													pattern="text"
													inputmode="text"
													placeholder={__('Search by store name or location')}
												/>
												<IonIcon icon={search} slot='start' />

											</IonItem>
											<Spacer size={2} />

										</div>
									}

									<CuratedMenusLink saveOrderData={this.props.location?.state?.saveOrderData} />

									<div className="order-locations-wrapper">
										<IonList className={` ${getConfig().general.tiledRestaurantView ? 'tiled-box-wrapper ' : 'box-wrapper'}`}>
											{filteredRestaurants.length > 0 ?
												<>
													{filteredRestaurants.map((store, i) => (
														<React.Fragment key={`store_${i}`}>
															{getConfig().general.tiledRestaurantView ? (
																<IonItem
																	className="pointer box-wrapper"
																	disabled={this.scheduledCollectionOnMultiVenueDisabled(store) || resturantIsDisabled || !store.opened}
																	onClick={() => this.selectRestaurant(store.id)}
																	lines="none"
																	key={i}
																>
																	<div style={{ width: '100%' }}>
																		<img src={store.image} />
																		<div>
																			<StrongText className='text-to-update block'>{__(store.name)}</StrongText>
																			<div className="restaurant-data" dangerouslySetInnerHTML={{ __html: store.info_html }}></div>
																		</div>
																		<SmallText className="restaurant-status" >{__(store.openLabel)}</SmallText>

																	</div>
																	<IonCheckbox checked={selectedRestaurant && store.id === selectedRestaurant} slot="start" color="primary" />
																</IonItem>
															) : (
																<IonItem
																	disabled={this.scheduledCollectionOnMultiVenueDisabled(store) || resturantIsDisabled || !store.opened}
																	onClick={() => this.selectStore(store)}
																	lines="none"
																	key={i}
																>
																	<IonLabel className="break-space">
																		<StrongText className='block text-to-update'>{__(store.name)}</StrongText>
																		<Spacer size={0} />
																		<SmallText className="block">{__(store.address)}</SmallText>
																		{store.distance && !Basket.has_multi_basket && (
																			<SmallText className=" block bold-description click-collect-small-description">
																				{`${parseFloat(store.distance.toFixed(2)) == 1 ? store.distance.toFixed(0) : store.distance.toFixed(2)} ${__(getDistanceUnit(parseFloat(store.distance.toFixed(2)) == 1))}`}
																			</SmallText>
																		)}
																		<SmallText className="restaurant-opening-time" >{__(store.openLabel)}</SmallText>
																	</IonLabel>
																	<IonCheckbox className='round-checkbox' checked={selectedRestaurant && store.id === selectedRestaurant} slot="start" color="primary" />
																</IonItem>
															)}
														</React.Fragment>
													))}</>
												:
												<div className='centered'>
													<NormalText>{__('No locations found')}</NormalText>
												</div>
											}
										</IonList>
									</div>

									{getConfig().frenchDisclaimer?.disclaimerImage && (
										<>
											<Spacer size={5} />

											<div className="disclaimer-wrapper">
												<img src={getConfig().frenchDisclaimer?.disclaimerImage}></img>
											</div>
										</>
									)}
									{!getConfig().general.tiledRestaurantView && (
										<>
											<Spacer size={5} />

											<IonButton
												{...(getConfig()?.customButtons?.order?.collection && { style: { '--ion-color-primary': getConfig()?.customButtons?.order?.collection } })}
												disabled={!selectedRestaurant || formatedStores.length === 0 || this.isRestaurantOpenForReorder(formatedStores, selectedRestaurant)}
												expand="block"
												color="primary"
												className='button-uppercase'
												onClick={() => {
													if (getConfig().flags.hasCollectionRestaurantCheck && !Basket.has_multi_basket) {
														this.setState({ isSubmitRestaurantAlertOpen: true })

													} else {
														this.setState({ filterValue: '' }, () => {
															this.selectRestaurant(selectedRestaurant)
														})
													}
												}}
											>
												{__('Continue')}
											</IonButton>
										</>
									)}
								</> : <div className='centered'>
									<StrongText className='text-to-update page-title-centered'>{__(`Sorry, ${this.props.scheduled ? 'scheduled click & collect' : 'click & collect'} is not available at this time...`)}</StrongText>

								</div>}
							</>
						) : this.props.scheduled ? (
							<>
								<Title className="web-only page-title-centered">{__('Scheduled click & collect')}</Title>
								<StrongText className='text-to-update bold page-title-centered'>{__('Select a pickup time')}</StrongText>
								<Spacer size={2} />
								<div className="time-picker-wrapper box-wrapper ">
									<mobiscroll.Treelist
										display="inline"
										layout="liquid"
										showInput={false}
										circular={false}
										ref={this.timeSlotRef}
										focusOnClose={false}
										themeVariant="light"
										theme="ios"
										width={(280, 260)}
										placeholder={__('Select Collection Time')}
										onSet={(e, instance) => {
											const newInstance = new Object(instance);
											instance.setVal(newInstance._tempWheelArray, true, true, true);
											this.parseSelectedTime(instance._tempValue);
										}}
										onInit={() => this.parseSelectedTime('init')}
										scrollLock
									>
										{Object.keys(this.timePickerOptions).map((date, i) => (
											<li key={i} data-val={date}>
												<span className={`item-date-picker ${this.timePickerOptions[date][0].time === 'CLOSED' && 'striked'}`}>{date}</span>
												<ul>
													{this.timePickerOptions[date].map((time, j) => (
														<li key={j} data-val={time.time}>
															<span className={`item-date-picker ${time.snoozed && 'striked'}`}>{time.time === 'CLOSED' ? 'UNAVAILABLE' : time.displayText}</span>
														</li>
													))}
												</ul>
											</li>
										))}
									</mobiscroll.Treelist>
								</div>

								{hasPickUpText && (
									<div dangerouslySetInnerHTML={{ __html: pickUpText }} />
								)}
								<Spacer size={5} />

								<IonButton
									disabled={!pickTime}
									expand="block"
									color="primary"
									className={`button-uppercase ${this.state.continueButtonClicked ? 'unclicked' : ''}`}
									onClick={() => this.chooseMenusForLocation()}
								>
									{__('Continue')}
								</IonButton>
							</>
						) : showOnlyPickUpText ? (
							<>
								{hasPickUpText && (
									<div dangerouslySetInnerHTML={{ __html: pickUpText }} />
								)}
								<Spacer size={5} />

								<IonButton
									disabled={!pickTime}
									expand="block"
									color="primary"
									className={`${this.state.continueButtonClicked ? 'unclicked' : ''} button-uppercase`}
									onClick={() => this.chooseMenusForLocation()}
								>
									{__('Continue')}
								</IonButton>
							</>
						) : (
							<>
								<Title className="web-only page-title-centered">{__('Click & collect order')}</Title>
								<StrongText className='bold text-to-update page-title-centered'>{__('Select an available time to collect your order')}</StrongText>
								<Spacer size={2} />

								<div className="time-picker-wrapper box-wrapper ">
									<SelectOption
										cssClass={isWebConfig() ? 'web' : ''}

										theme='ios'
										wheels='3d'
										display="inline"
										onSet={(e, inst) => this.setPickTime(inst, minDT)}
										data={this.timePickerOptions}
										circular={false}
										label="Location"
										value={pickTime}
										inputStyle="box"
										placeholder={__('Select Collection Time')}
										setText={__('OK')}
										cancelText={__('Cancel')}
										disabled={this.state.selectedRestaurant === null ? true : false}
										onInit={() => {
											if (this.timePickerOptions.length > 0) {
												const firstAvailableTime = this.timePickerOptions.find((i) => i.value !== null && !snoozedTimes.includes(i.value));
												if (!pickTime && firstAvailableTime && pickTime !== firstAvailableTime.value) {
													this.changeTime(firstAvailableTime.value, minDT);
												}
											}
										}}
									/>
								</div>
								{hasPickUpText && (
									<div dangerouslySetInnerHTML={{ __html: pickUpText }} />
								)}
								<Spacer size={5} />

								<IonButton
									disabled={!pickTime}
									expand="block"
									color="primary"
									className={`button-uppercase ${this.state.continueButtonClicked ? 'unclicked' : ''}`}
									onClick={() => this.chooseMenusForLocation()}
								>
									{__('Continue')}
								</IonButton>

								<div style={{ padding: 'var(--ion-padding)', textAlign: 'center' }}>
									<NormalText>
										{__('You have 5 minutes to complete your order to guarantee this collection time.')}
									</NormalText>
								</div>



							</>
						)}
					</div>
					{!menus.length ? null : (
						<>
							<Modal
								isOpen={isChooseMenuModalOpen}
								onDidDismiss={() => {
									this.props.dispatch(setCommonModal('isChooseMenuModalOpen', false))
								}}
							>
								<Title className='modal-title'>{__('Choose menu')}</Title>
								<Spacer size={5} />
								<IonList lines="none" className="box-wrapper menus-wrapper">
									<IonRadioGroup onIonChange={this.changeIkentooMenus} value={selectedIkentooMenu}>
										{!menus.length ? (
											<NoData />
										) : (
											menus.map((menu) => {
												const { ikentooMenuId, menuName } = menu;
												return (
													<IonItem key={ikentooMenuId} lines="none">
														<StrongText className="ion-text-wrap">
															{menuName}
														</StrongText>
														<IonRadio color='primary' slot="start" value={ikentooMenuId} />
													</IonItem>
												);
											})
										)}
									</IonRadioGroup>
								</IonList>
								<Spacer size={5} />
								<IonButton
									disabled={pickTime && menus.length > 0 ? false : true}
									expand="block"
									color="primary"
									className="customized-button button-uppercase"
									onClick={() => this.continueOnMenu()}
								>
									{__('Continue')}
								</IonButton>
							</Modal>


						</>
					)}
				</Layout>
				<IonAlert
					isOpen={this.state.isSubmitRestaurantAlertOpen}
					onDidDismiss={() => this.setState({ isSubmitRestaurantAlertOpen: false })}
					header={__('Please confirm collection from this location')}
					message={__(this.getRestautantDataMessage(selectedRestaurant))}
					buttons={[
						{
							text: __('Confirm'),
							role: 'submit',
							cssClass: 'primary',
							handler: () =>
								this.setState({ isSubmitRestaurantAlertOpen: false, filterValue: '' }, () => {
									this.selectRestaurant(selectedRestaurant);
								}),
						},
						{
							text: __('Change'),
							role: 'cancel',
							cssClass: 'link secondary',
							handler: () => this.setState({ isSubmitRestaurantAlertOpen: false }),
						},
					]}
				/>
			</Loading>
		);
	}
}

const stateToProps = (state) => {
	const { isChooseMenuModalOpen, orderProductionMins, myLocation } = state.common;
	const { restaurants, ikentooMenu, isShowTimePicker, ikentooMenusForLocation, continueScheduleOrdering } = state.restaurants;
	const { deliveryOption } = state.orders;
	const { profile, auth } = state.profile
	return {
		auth,
		isChooseMenuModalOpen: isChooseMenuModalOpen,
		restaurants: restaurants || [],
		ikentooMenu: ikentooMenu || {},
		ikentooMenusForLocation: ikentooMenusForLocation || [],
		profile,
		isShowTimePicker: isShowTimePicker,
		deliveryOption,
		orderProductionMins: orderProductionMins,
		auth,
		continueScheduleOrdering,
		myLocation
	};
};

export default connect(stateToProps)(withTranslation(ClickAndCollect));
